export default __webpack_public_path__ + "static/media/telegram.424e4a27.svg";